import withLazyLoading from '../../hoc/withLazyLoading';
import { ACCOUNT_ROUTES } from '../../navigation/paths';
import { createCrumbHandle, withCrumbParents } from '../../utilities/auth';
import { EVERYONE, access } from '../../access';

import { guardedRoute } from './guardedRoute';

const FEATURE = 'account';

const ContactProfileScreen = withLazyLoading(() =>
  import('../../modules/account/components/ContactProfileScreen').then((m) => ({
    default: m.ContactProfileScreen,
  })),
);

const ChangePasswordScreen = withLazyLoading(() =>
  import('../../modules/account/components/ChangePasswordScreen').then((m) => ({
    default: m.ChangePasswordScreen,
  })),
);

const accountRoutes = [
  {
    path: ACCOUNT_ROUTES.contact,
    element: guardedRoute(FEATURE, <ContactProfileScreen />),
    handle: { ...createCrumbHandle('Profile'), ...access(EVERYONE) },
  },
  {
    path: ACCOUNT_ROUTES.password,
    element: guardedRoute(FEATURE, <ChangePasswordScreen />),
    handle: { ...withCrumbParents(createCrumbHandle('Password'), [{ label: 'Profile', pathname: ACCOUNT_ROUTES.contact }]), ...access(EVERYONE) },
  },
];

export default accountRoutes;
